<template>
  <div class="ima-sign-editor-toolbar">
    <slot></slot>
  </div>
</template>


<script>
export default {
  name: 'ima-sign-editor-toolbar',
  data () {
    return {}
  }
}
</script>


<style scoped lang="scss">
@import '../scss/settings';
.ima-sign-editor-toolbar {
  align-self: flex-start;
  background-color: $secondary;
  border: 1px solid darken($secondary, 10);
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  margin-right: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0.8rem;
  z-index: 1;

  a,
  button {
    margin-bottom: 0.8rem;
    width: 100%;
  }

  hr {
    background-color: transparent;
    margin: 0.5rem 0;
  }

  .has-addons {
    margin-bottom: 0;
    width: 100%;
    .fullwidth {
      width: 100%;
    }
    button {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignEditorToolbar.vue